// src/pages/CongressPage.jsx
// Congressional Trade Tracker — Member Page.
// Design docs: CONGRESSIONAL-TRADE-MEMBER-PAGE-DESIGN.md,
// CONGRESSIONAL-PAGE-REDESIGN-DESIGN.md.
//
// THIN SHELL (this pass) — the original build had all four tabs' full logic
// inline in this one file. Split into src/components/congressional/
// {TradeFeedTab,MemberProfilesTab,CommitteeViewTab,InsightsTab}.jsx, matching
// this codebase's own existing precedent for a multi-tab page
// (ReviewConsoleTab.jsx/TradeBrowserTab.jsx, Ops repo) rather than inventing
// a new pattern. This file now owns only: page header, tab navigation state,
// and passing the right props to whichever tab is active.
//
// FOUR TABS: Trade Feed, Member Profiles, Committee View, Insights (NEW this
// pass). Tab 5 (Smart Money Alignment) still NOT built — blocked on OCI-5G +
// REFACTOR-EDGAR, per the original design doc's own sequencing note.
//
// onNavigate is threaded through to every tab that needs it (Trade Feed,
// Member Profiles, Committee View) so a member name/row anywhere on this
// page can route to the Member Detail Subpage (CongressMemberPage.jsx) —
// this is the real fix for the redesign's own confirmed gap: a member name
// used to appear in three places on this page and lead nowhere in any of
// them.

import { useState } from 'react';
import { Landmark, Users, Building2, TrendingUp } from 'lucide-react';
import TradeFeedTab from '../components/congressional/TradeFeedTab';
import MemberProfilesTab from '../components/congressional/MemberProfilesTab';
import CommitteeViewTab from '../components/congressional/CommitteeViewTab';
import InsightsTab from '../components/congressional/InsightsTab';

export default function CongressPage({ isLoggedIn, token, onRequestInvite, onSignIn, onNavigate }) {
  const [tab, setTab] = useState('feed');

  return (
    <div style={{ padding: '2rem 1rem' }}>
      <div style={{ marginBottom: '1.25rem' }}>
        <h1 style={{ margin: 0, color: '#f1f5f9', fontSize: '1.4rem', fontWeight: 700 }}>Congressional Trades</h1>
        <p style={{ margin: '0.25rem 0 0', color: '#64748b', fontSize: '0.85rem' }}>
          House + Senate STOCK Act disclosures — filing lag, ownership type, and conviction weight
          shown alongside every trade, not just the raw filing.
        </p>
      </div>

      <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '0.5rem', flexWrap: 'wrap' }}>
        {[
          { id: 'feed', label: 'Trade Feed', icon: Landmark },
          { id: 'members', label: 'Member Profiles', icon: Users },
          { id: 'committees', label: 'Committee View', icon: Building2 },
          { id: 'insights', label: 'Insights', icon: TrendingUp },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.6rem 1.1rem', borderRadius: '8px', border: 'none', background: tab === t.id ? 'rgba(0,255,136,0.12)' : 'transparent', color: tab === t.id ? '#00ff88' : '#64748b', cursor: 'pointer', fontSize: '0.85rem', fontWeight: tab === t.id ? 700 : 500 }}>
            <t.icon size={14} />{t.label}
          </button>
        ))}
      </div>

      {tab === 'feed' && <TradeFeedTab token={token} onRequestInvite={onRequestInvite} onNavigate={onNavigate} />}
      {tab === 'members' && <MemberProfilesTab token={token} onNavigate={onNavigate} />}
      {tab === 'committees' && <CommitteeViewTab token={token} onNavigate={onNavigate} />}
      {tab === 'insights' && <InsightsTab token={token} />}
    </div>
  );
}
